/* eslint-disable no-console -- thin compatibility shim for source-ported utilities */
import type { Logger, LoggerOptions } from '@/types/Logger';

function createConsoleLogger(namespace: string): Logger {
  const prefix = `[${namespace}]`;
  let enabled = true;

  return {
    error: (...args: unknown[]) => {
      if (enabled) console.error(prefix, ...args);
    },
    warn: (...args: unknown[]) => {
      if (enabled) console.warn(prefix, ...args);
    },
    info: (...args: unknown[]) => {
      if (enabled) console.info(prefix, ...args);
    },
    debug: (...args: unknown[]) => {
      if (enabled) console.debug(prefix, ...args);
    },
    trace: (...args: unknown[]) => {
      if (enabled) console.debug(prefix, ...args);
    },
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
    getNamespace: () => namespace,
  };
}

export type { Logger };

export function createLogger(options: LoggerOptions): Logger {
  return createConsoleLogger(options.namespace);
}
